import { Command, Option } from "clipanion";
import { M8tCommand } from "../../lib/m8t-command.js";
import { readConfig, getConfigPath } from "../../lib/config.js";
import { readFoundryConfig, getFoundryConfigPath } from "../../lib/foundry-config.js";
import {
  colors,
  renderJson,
  renderKeyValueBlock,
  resolveOutputMode,
} from "../../lib/output.js";

export class ConfigShowCommand extends M8tCommand {
  static paths = [["config", "show"]];
  static usage = Command.Usage({
    description: "Show ~/.m8t-stack/config.yaml (tenant/client/project) + the cached gateway.",
    details:
      "Displays the Foundry config (config.yaml) and the gateway discovery cache (cli-config.yaml).",
  });

  output = Option.String("--output");

  async executeCommand(): Promise<number> {
    const mode = resolveOutputMode(
      this.output as "pretty" | "json" | "auto" | undefined,
      this.context.stdout as NodeJS.WriteStream,
    );
    const foundry = await readFoundryConfig();
    const cache = await readConfig();

    if (mode === "json") {
      this.context.stdout.write(renderJson({ foundry, gatewayCache: cache }) + "\n");
      return 0;
    }

    const foundryBlock = foundry
      ? renderKeyValueBlock([
          { key: "tenant", value: foundry.tenantId },
          { key: "client id", value: foundry.clientId },
          { key: "project", value: foundry.projectName },
          { key: "endpoint", value: foundry.projectEndpoint },
        ])
      : colors.dim(`no config.yaml — create it with 'm8t switch' or 'm8t config set'`);
    this.context.stdout.write(colors.field("Foundry config") + ` (${getFoundryConfigPath()})\n`);
    this.context.stdout.write(foundryBlock + "\n\n");

    this.context.stdout.write(colors.field("Gateway cache") + ` (${getConfigPath()})\n`);
    if (!cache) {
      this.context.stdout.write(
        colors.dim("no cached gateway URL — will discover on next command.") + "\n",
      );
      return 0;
    }
    this.context.stdout.write(
      renderKeyValueBlock([
        { key: "gateway", value: cache.gatewayUrl },
        { key: "client id", value: cache.gatewayClientId },
        { key: "tenant", value: cache.gatewayTenantId },
        { key: "subscription", value: cache.subscriptionId },
        { key: "container app", value: cache.containerAppResourceId },
        { key: "cached at", value: cache.cachedAt },
      ]) + "\n",
    );
    return 0;
  }
}
